import React, { useState } from "react";
import { Tabs, Button } from "antd";
import Main from "../../components/layout/Main";
import TumanentImage from "../../assets/images/tunamnet-tubhnail-image.jpg";
import GamesImage from "../../assets/images/games-image.jpg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import AuctionImage from "../../assets/images/auction-image.png";
import CoinImage from "../../assets/images/coin-image.svg";
import { useAuction } from "../../context/AuctionContext";
import { useNavigate } from "react-router";
import { isValidUrl } from "../../helper/functions";

const { TabPane } = Tabs;

const MyBidsIndex = () => {
  const [ongoingBids, setOngoingBids] = useState([]);
  const [completedBids, setCompletedBids] = useState([]);
  const [activeTab, setActiveTab] = useState("OngoingBids");
  const navigate = useNavigate();
  const { loadUserBids } = useAuction();
  const fetchBids = async (tabKey) => {
    try {
      const response = await loadUserBids({ filter: tabKey });
      if (response.status === 200) {
        if (tabKey === "OngoingBids") {
          setOngoingBids(response.data.items);
        } else {
          setCompletedBids(response.data.items);
        }
      }
    } catch (error) {
      console.log("error in fetch bids", error);
    }
  };

  // ------------- use effects ---------
  React.useEffect(() => {
    fetchBids(activeTab);
  }, [activeTab]);

  return (
    <Main>
      <div className="home-container">
        <div className="orange-header">My Bids</div>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="custom-tabs-bordered"
        >
          <TabPane tab="Ongoing Bids" key="OngoingBids">
            <div className="my-bideslist">
              <div className="for-feature-grid-main">
                {ongoingBids?.map((bid, index) => (
                  <div className="auction-inner-card" key={index}>
                    <img
                      src={
                        isValidUrl(bid?.images?.[0])
                          ? bid?.images?.[0]
                          : AuctionImage
                      }
                    />
                    <div className="product-name">
                      <div className="bids-product-name-active">
                        <Button className="success-btn">Active</Button>
                        <h4>{bid?.itemName}</h4>
                      </div>
                      <p>2h left</p>
                    </div>
                    <div className="bid-price">
                      <img src={CoinImage} />
                      <h4>
                        Current Bid :
                        <span className="green">{bid?.currentBid} Tokens</span>
                      </h4>
                    </div>
                    <div className="bid-price">
                      <img src={CoinImage} />
                      <h4>
                        Your Bid :
                        <span className="red">{bid?.yourBid} Tokens</span>
                      </h4>
                    </div>
                    <Button
                      className="bid-button"
                      onClick={() =>
                        navigate(`/auctions/auctions-detail/${bid?._id}`)
                      }
                    >
                      Bid Now
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          </TabPane>
          <TabPane tab="Completed Bids" key="CompletedBids">
            <div className="my-bideslist">
              <div className="for-feature-grid-main">
                {completedBids.map((bid, index) => (
                  <div
                    key={index}
                    className="auction-inner-card completed-bids-card"
                    onClick={() =>
                      navigate(`/bids/bid-detail/${bid._id}?tab=${activeTab}`)
                    }
                  >
                    <img
                      src={
                        isValidUrl(bid?.images?.[0])
                          ? bid?.images?.[0]
                          : AuctionImage
                      }
                    />
                    <div className="product-name">
                      <div className="bids-product-name-active">
                        <Button className="win-btn">✅ {bid?.status}</Button>
                        <h4>{bid?.itemName}</h4>
                      </div>
                      <p> Ended: {bid?.endDate}</p>
                    </div>
                    <div className="bid-price">
                      <img src={CoinImage} />
                      <h4>
                        Current Bid :
                        <span className="green">{bid?.currentBid} Tokens</span>
                      </h4>
                    </div>
                    <div className="bid-price">
                      <img src={CoinImage} />
                      <h4>
                        Your Bid :
                        <span className="red">{bid?.yourBid} Tokens</span>
                      </h4>
                    </div>
                    {/* <Button
                      className="bid-button"
                      onClick={() => navigate("/bids-detail")}
                    >
                      Bid Now
                    </Button> */}
                  </div>
                ))}
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </Main>
  );
};

export default MyBidsIndex;
